(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  if (window.matchMedia('(min-width: 990px)').matches) {
    let lastClosedMenu;
    let lastClosedRect;
    let reopenUntil = 0;
    const reopenWindowMs = 500;
    const fadeOutMs = 500;

    document.querySelectorAll('.mega-menu__content').forEach((contentElement) => {
      void contentElement.getBoundingClientRect();
      void window.getComputedStyle(contentElement).opacity;
    });

    const tryReopenLastMenu = (event) => {
      if (!lastClosedMenu || !lastClosedRect || Date.now() > reopenUntil) return;

      const currentlyOpenMenu = Array.from(document.querySelectorAll('.mega-menu[open]')).find(
        (openMenuElement) => openMenuElement !== lastClosedMenu && !openMenuElement.classList.contains('is-closing')
      );

      if (currentlyOpenMenu) return;

      const { clientX, clientY } = event;
      const pointedElement = document.elementFromPoint(clientX, clientY);
      const pointedMenu = pointedElement ? pointedElement.closest('.mega-menu') : null;

      if (pointedMenu && pointedMenu !== lastClosedMenu) return;

      const isInsideLastPanel =
        clientX >= lastClosedRect.left &&
        clientX <= lastClosedRect.right &&
        clientY >= lastClosedRect.top &&
        clientY <= lastClosedRect.bottom;

      if (!isInsideLastPanel) return;

      document.querySelectorAll('.mega-menu[open]').forEach((openMenuElement) => {
        if (openMenuElement !== lastClosedMenu) {
          window.clearTimeout(openMenuElement._closeTimer);
          window.clearTimeout(openMenuElement._closeAnimationTimer);
          openMenuElement.classList.remove('is-closing');
          openMenuElement.removeAttribute('open');
        }
      });

      window.clearTimeout(lastClosedMenu._closeTimer);
      window.clearTimeout(lastClosedMenu._closeAnimationTimer);
      lastClosedMenu._stateVersion = (lastClosedMenu._stateVersion || 0) + 1;
      lastClosedMenu.classList.remove('is-closing');
      if (!lastClosedMenu.hasAttribute('open')) {
        lastClosedMenu.setAttribute('open', '');
      }
      lastClosedMenu = null;
      lastClosedRect = null;
      reopenUntil = 0;
    };

    document.addEventListener('mousemove', tryReopenLastMenu);

    document.querySelectorAll('.mega-menu').forEach((menu) => {
      const summary = menu.querySelector('summary');
      const content = menu.querySelector('.mega-menu__content');
      let closeTimer;
      let closeAnimationTimer;
      menu._stateVersion = menu._stateVersion || 0;

      const clearMenuTimers = (menuElement) => {
        window.clearTimeout(menuElement._closeTimer);
        window.clearTimeout(menuElement._closeAnimationTimer);
      };

      const openMenu = () => {
        menu._stateVersion = (menu._stateVersion || 0) + 1;
        clearMenuTimers(menu);
        menu.classList.remove('is-closing');

        if (lastClosedMenu && lastClosedMenu !== menu) {
          lastClosedMenu = null;
          lastClosedRect = null;
          reopenUntil = 0;
        }

        if (!menu.hasAttribute('open')) {
          menu.setAttribute('open', '');
          if (content) {
            void content.offsetHeight;
          }
        }

        document.querySelectorAll('.mega-menu[open]').forEach((openMenuElement) => {
          if (openMenuElement !== menu) {
            openMenuElement._stateVersion = (openMenuElement._stateVersion || 0) + 1;
            clearMenuTimers(openMenuElement);
            openMenuElement.classList.add('is-closing');
            const closingVersion = openMenuElement._stateVersion;
            openMenuElement._closeAnimationTimer = window.setTimeout(() => {
              if (openMenuElement._stateVersion !== closingVersion) return;
              openMenuElement.removeAttribute('open');
              openMenuElement.classList.remove('is-closing');
            }, fadeOutMs);
          }
        });
      };

      const closeMenu = () => {
        const stateVersion = (menu._stateVersion || 0) + 1;
        menu._stateVersion = stateVersion;

        clearMenuTimers(menu);
        closeTimer = window.setTimeout(() => {
          if (menu._stateVersion !== stateVersion) return;

          const anotherOpenMenu = Array.from(document.querySelectorAll('.mega-menu[open]')).find(
            (openMenuElement) => openMenuElement !== menu && !openMenuElement.classList.contains('is-closing')
          );

          if (!anotherOpenMenu && content) {
            const contentRect = content.getBoundingClientRect();
            const summaryRect = summary ? summary.getBoundingClientRect() : null;

            lastClosedMenu = menu;
            lastClosedRect = {
              left: Math.min(summaryRect ? summaryRect.left : contentRect.left, contentRect.left),
              right: Math.max(summaryRect ? summaryRect.right : contentRect.right, contentRect.right),
              top: Math.min(summaryRect ? summaryRect.bottom : contentRect.top, contentRect.top),
              bottom: contentRect.bottom,
            };
            reopenUntil = Date.now() + reopenWindowMs;
          } else if (lastClosedMenu === menu) {
            lastClosedMenu = null;
            lastClosedRect = null;
            reopenUntil = 0;
          }

          menu.classList.add('is-closing');
          closeAnimationTimer = window.setTimeout(() => {
            if (menu._stateVersion !== stateVersion) return;
            menu.removeAttribute('open');
            menu.classList.remove('is-closing');
          }, fadeOutMs);
          menu._closeAnimationTimer = closeAnimationTimer;
        }, 120);

        menu._closeTimer = closeTimer;
      };

      menu.addEventListener('mouseenter', openMenu);
      menu.addEventListener('mouseleave', closeMenu);

      if (summary) {
        summary.addEventListener('click', (event) => {
          const clickedLink = event.target instanceof Element && event.target.closest('a');

          if (clickedLink) return;

          event.preventDefault();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
